import React from "react";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {MainHeader} from "../Components/MainHeader/MainHeader";
import SecondRowInHeaderContainer from "../Components/SecondRowInHeader/SecondRowInHeaderContainer";
import HeaderContainer from "../Components/Header/HeaderContainer";
import ContentContainer from "../Components/Content/ContentContainer";
import Footer from "../Components/Footer/Footer";

const theme = createTheme({
    palette: {
        primary: {
            main: '#E5870E',
            light: `#e6b373`,
        },
    },
    typography: {
        fontFamily: `"Arial", "Helvetica", "Roboto", sans-serif`,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    minWidth: 'auto',
                    padding: `5px`,
                    ':hover': {
                        backgroundColor: '#E5870E'
                    },
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    letterSpacing: '0.2px',
                    // fontFamily: `avenir, avenir next, Helvetica Neue, Arial, sans-serif`
                }
            },
            variants: [
                {
                    props: {variant: 'body1'},
                    style: {
                        fontSize: `14px`
                    },
                },
                {
                    props: {variant: 'body2'},
                    style: {
                        fontSize: `20px`
                    },
                },
                {
                    props: {variant: 'h1'},
                    style: {
                        fontSize: `20px`
                    },
                },
                {
                    props: {variant: 'h2'},
                    style: {
                        fontSize: `18px`
                    },
                },
                {
                    props: {variant: 'h3'},
                    style: {
                        fontSize: `16px`
                    },
                },
                {
                    props: {variant: 'h4'},
                    style: {
                        fontSize: `14px`
                    },
                },

                {
                    props: {variant: 'h5'},
                    style: {
                        fontSize: `12px`
                    },
                },

                {
                    props: {variant: 'h6'},
                    style: {
                        fontSize: `10px`
                    },
                },
            ],
        },
    },
});


export const AppScreen = () => {
    return (
        <ThemeProvider theme={theme}>
            <div className="app-wrapper">
                <div className="header-background">
                    <MainHeader/>
                    <SecondRowInHeaderContainer/>
                    <HeaderContainer/>
                </div>
                <ContentContainer/>
                <Footer/>
            </div>
        </ThemeProvider>
    )
}